import objectToQueryParams from './objectToQueryParams'

const getBoxPositionOnWindowCenter = (width, height) => ({
  left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
  top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
})

const openWindow = (
  url,
  { name = 'Share window', query = {}, height = 400, width = 550, onClose, ...configRest } = {}
) => {
  const defaultConfig = {
    height,
    width,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes',
    ...getBoxPositionOnWindowCenter(width, height),
    ...configRest,
  }

  const shareDialog = window.open(
    `${url}${objectToQueryParams(query)}`,
    name,
    Object.keys(defaultConfig)
      .map(key => `${key}=${defaultConfig[key]}`)
      .join(', ')
  )

  if (onClose) {
    const interval = window.setInterval(() => {
      try {
        if (shareDialog === null || shareDialog.closed) {
          window.clearInterval(interval)
          onClose(shareDialog)
        }
      } catch (e) {
        /* eslint-disable no-console */
        console.error(e)
      }
    }, 500)
  }

  return shareDialog
}

export default openWindow
